module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Central Wyoming Territory—Fall, 1889")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("S")])])])]), _vm._v("he moved with the caution of a doe caught grazing in an open meadow. Her dirt-stained fingers quickly secured a rope behind her saddle, binding her supplies as she discreetly watched the men filing out of the newly constructed town hall.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Following a roomful of grumbling cattlemen out onto the boardwalk, Garret Daines spotted the woman they called Mad Mag the moment he stepped into the crisp evening air. Her mangy bearskin coat and battered brown hat was hard to miss in the fading light of an otherwise deserted street. Murmurs of recognition and surprise rumbled through the crowd of men.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Garret had seen the mountain recluse in a town only one other time in the eight years he’d lived in these Wyoming hills, some years back in a settlement further north. The bushel of tangled black hair beneath her hat suggested she could still benefit from a lesson or two in hygiene. Known for having a temperament on the far side of crazy, Mad Mag tended to avoid folks altogether. She obviously hadn’t expected all the cattlemen within fifty miles to spill out onto the streets of Bitterroot Springs at five o’clock in the evening. He glanced ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("around at the men watching her with an equal measure of curiosity and caution.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“What’s the plan?” Duce asked, clapping a hand on Garret’s shoulder as he stepped beside him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Garret glanced over at his business partner, the man’s wide grin striking him as a pure wonder. The past two hours of heated debates and near brawls, two of which had included Garret, left an ache in his shoulders, the frustration winding inside him still burning for release. In the fourteen years he’d been riding with Duce the wiry cowpuncher had never known a sour mood.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("He doesn’t handle the account books,")])]), _vm._v(" he silently retorted. Duce had signed on as his partner in name only, refusing to take a cut or responsibility for a business he hadn’t funded. At the age of forty-two, Duce still lived for Saturday nights and blowing his paycheck on weekend benders. In the past six years of running his cattle ranch, Garret had come to envy Duce’s carefree attitude and figured the past few winters had closed the wide gap in their ages.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Garret felt old. Nothing like a failed marriage and Old Man Winter cramming his boot up your behind to age a man.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("He glanced out at a pink-streaked sky. “Sun’s about down. Might as well spend the night.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Duce gave a nod. He raked his fingers through his bushy red hair glowing bright beneath a streetlamp then tugged on his hat. “Think I’ll head over to the Gilded Lady. Winter snow will be piling up soon and my girls are bound to miss me. Care to come along?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Not in the mood.” He shook his head, a weary sigh breaking from his chest. “I feel like I’ve just been ambushed by seven cattle barons.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Duce chuckled.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Garret didn’t share his humor. To secure his place in the stockyards come spring he’d signed over a small fortune to ")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("the wealthy bandits of the newly appointed Cattlemen’s Association. They’d seemed rather disappointed in his ability to meet their demands. He wasn’t about to be pushed off his land. He’d faired better than many of his colleagues, men who’d lost all their stock in the freeze a couple of winters back, a blizzard that had damn near wiped out the cattle trade across the state. Now the railroad and invading cattle barons circled like vultures, ready to pick off the smaller ranches struggling to make ends meet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“I’ll settle for a pint of whiskey and passing out in a hotel room.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“You can do that over at the Gilded Lady,” Duce persisted. “What you need is a night in the saddle with some wild women. Ain’t no reason for you not to.” He moved closer as they stepped into the street. “Amanda’s not coming back, you know?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Garret rolled his shoulders against the surge of anger and resentment tightening his muscles. “I sure as hell hope not.” Staring at that outrageous cattlemen contract reminded him of the divorce papers he’d finally signed last spring—cutting his marital ties to a woman he’d not seen in nearly three years. A wife walking out on a marriage left a man with no small amount of humiliation. He didn’t see the need to announce his divorce.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Life sure hadn’t gone the way he’d planned. Having acquired his ranch at the age of sixteen and marrying at nineteen, he truly thought he’d be settled in with his own family by now, not contemplating a night at a brothel. Damned if he could figure out what he’d done wrong. One thing he did know: he was through chasing women. If he was to have another wife, she’d have to run him to ground first.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“You can slug me for saying so,” said Duce, “but you’re lucky to be rid of that one. All that pretty was wasted on a woman who don’t do nothin’ but sniffle and pout ’cause you’re too busy to sit and stare at her all damn day.”")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The truth didn’t keep Garret’s chest from burning at the thought of Amanda Billings standing on his sister’s front porch bound and bustled in the fanciest gear he’d ever seen. The daughter of a Southern banker, she was a true belle, her soft-spoken voice never reaching much above a whisper, her long, lithe body and graceful movements "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("mesmerizing.")])]), _vm._v(" The fact that she’d looked twice at his weather-beaten hide had lit his fire, and he’d sure as hell lit hers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Passion hadn’t been enough to hold her. After eight months of marriage Amanda had her fill of him and Wyoming winters—a winter like nothing he’d ever seen. He wasn’t new to tragedy or hardship. Raised on cattle trails by his older sister, he’d survived raids, floods, droughts and damn near being washed out of a Colorado Canyon—none of it had prepared him for watching his livelihood go to hell in a frozen handcart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Murmurs buzzed from the men around him as Mad Mag guided her horse along the main strip. The top of her hat was barely visible beyond the large bay she led by the reins. A fine horse, its golden coat gleaming in the low light. His gaze stopped on the Morgan brand singed into the animal’s haunch—the brand of his sister’s ranch. He glanced again at the horse’s golden coat, black socks, the burst of white on the horse’s dark frock—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Star.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Is that Star?” he said to Duce as they stopped beside their own mounts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yep,” he answered, not bothering to shift his gaze toward the woman and her horse. “Chance sold his mare to the trapper, Ira Danvers just before you bought your ranch and we moved onto the Lazy J.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("That was six years back and he and Chance Morgan hadn’t been on good speaking terms, Chance having stolen his girl right out from under his nose. Still, he found it hard to believe Chance would sell his prized mare to someone like Ira ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Danvers. Garret had never actually met the mountain man, but had heard he was far less sociable than his woman.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“How can filth like that own a Morgan horse?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Garret glanced back at the newest member of the Cattlemen’s Association standing on the landing of the town hall, his expression filled with disgust. Strafford, the newly elected mayor of Bitterroot Springs, gripped the sides of his shiny blue jacket and stepped onto the walk, his group of ranch hands moving with him like a clutch of chickens scurrying after a peacock.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“Folks call her Mad Mag,” said one of his men. “Ain’t ever seen her in town before.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“Mad Mag?” Strafford’s gaze narrowed. He stepped off the boardwalk into the dusty road. “You there? Come back here.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("The woman increased her strides and urged the mare to move faster.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“Uh…Boss?” his man called after him. “I wouldn’t—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“Hey!” Strafford shouted. “I’m talking to you!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“He’s barkin’ up the wrong tree with that one,” Duce murmured.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Mad Mag turned into the alley beside the mercantile. Strafford hurried after her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“Someone might ought to fetch the sheriff,” suggested one of the men.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("“Who wants to bet Mayor Strafford just got a new mare?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("The large group erupted with laughter.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Anger snapped at Garret’s nerves. He’d disliked the overdressed rancher the moment he’d met the man. Nathan Strafford had moved into these hills with the greasy finesse of a snake-oil salesman, forcing out the smaller ranchers while pouring his money into this town. He’d funded a new school and the first courthouse in Bitterroot Springs, which had gotten him elected as the new town mayor.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Garret started across the road, damned if he’d stand by ")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("while that arrogant jackass took advantage of some poor deranged woman.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Garret?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Leaving Duce to chase after him, he rounded the building. Mag was near the far end of the alley, Strafford closing in on her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“We got new laws in this town,” Strafford announced, his long arm reaching for her. He grabbed a fistful of fur.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Mag spun to face him, the rifle in her hands forcing him to take a backward step. “Back off,” she growled.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Strafford’s six-plus frame towered over the small woman. “What business do you have in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("my")])]), _vm._v(" town?” he demanded. “Aside from reeking up the streets and stealing our horses?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("The woman’s cold, throaty laughter echoed through the hallow shadows of the narrow alley. “Oh, that’s rich. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("You")])]), _vm._v(" calling "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("me")])]), _vm._v(" a thief.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Strafford leaned closer to her. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Mag—?”")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("The butt of her rifle connected with Strafford’s gut, ending his words in a hard cough. He doubled over. She swung again, her rifle cracking against his skull, sending him staggering back. Another swift blow to the brow, and Strafford hit the ground like a fallen timber.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Damn.")])]), _vm._v(" Her reputation wasn’t just rumors. She stood over Strafford, the barrel of her rifle pressed to his chest. She trembled. Jagged puffs of breath lifted the tangled black hair covering most of her face. Her finger flexed over the trigger.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("If she shot Strafford, provoked or not, she’d hang before sundown.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“He’s not worth it,” Garret whispered, slowly moving in beside her while keeping an eye on that rifle.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Rage shaking her, Maggie couldn’t think of a single reason why she shouldn’t put a hole through Nathan’s black heart. He had no right to touch her—no right to be in this part of Wyoming!")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("His")])]), _vm._v(" town? Her gaze raked over his fancy suit. Bile burned in her throat. Did this town know the vile measures he used ")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("to acquire his wealth? It was past time for Nathan to be stomped back down to the devil.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("She startled at a light pressure on her shoulder. Her gaze snapped to the long fingers touching her fur coat. She glanced up at wide shoulders creating a clear line on the pink horizon.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Careful,” he said. “Sheriff’s coming.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Pale blond hair glowed white against the sunset, instantly identifying the man beside her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Garret Daines.")])]), _vm._v(" Recognition broke across her senses like a crack of lightning, shattering her tattered nerves. She’d spotted Daines and his cow dog often enough in the hills around her mountain, but never so close. He appeared rather like the Vikings she’d learned about during her studies as a young girl, his pale hair wavering in the cool breeze, the span of his chest blocking out the world. A colorful sky outlined his profile, defining the sharp lines and intriguing contours of his face.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Ma’am, you’d better git.” The hand on her shoulder urged her aside, jarring her from a mental stupor. Not that he noticed. His hard gaze never strayed from the murmur of voices growing louder by the second. He glanced to his right and his friend moved in beside him, completely blocking her from view of the approaching mob.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“What’s going on?” a man shouted.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“What happened to Mayor Strafford?” called another.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Not much that I could see,” said Daines. “Ol’ Strafford didn’t mind his footing. Tripped over his own boots and bumped his head.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Maggie stared up at Daines’s broad shoulders, staggered by his outright lie, his offer of protection. Seizing the opportunity, she grabbed Star by the reins and stepped around the corner of the building. She wouldn’t be back to this town.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Garret glanced over his shoulder as the crowd descended on Strafford, and was relieved to find the woman had fled. He looked at Duce and nodded in the direction she’d gone. They ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("prudently made a swift exit. Garret scanned the surrounding hills and tall grasses spotted by patches of trees and scrub. Mad Mag was nowhere in sight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“You got some kind of death wish I should know about?” asked Duce.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Why would you think—?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“You’re lucky that woman didn’t fill you full of buckshot. Or didn’t you see the way she laid out Strafford?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“She had a rifle, not a shotgun. And he likely frightened her, grabbing her the way he did.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Frightened "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("her?")])]), _vm._v(" That’s it,” Duce said, shoving him across the road. “We’re headed to the whorehouse before you end up dead or courting a mountain shrew.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Garret laughed, and didn’t argue. Watching that woman knock Strafford down a few notches had lightened his mood.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Finally a bit of justice in this world.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea8f5d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mountain_9781426835841_ch01.vue
// module id = 84
// module chunks = 0